import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { l10n } from '@ott/l10n';

import ActionButton from '../ActionButton';

import styles from './TravellersItem.scss';

class TravellersItem extends PureComponent {
  static propTypes = {
    index: PropTypes.number,
    withHeader: PropTypes.bool,
    groupTitle: PropTypes.string,
    dataLocator: PropTypes.string,

    adultsNode: PropTypes.node.isRequired,
    childrenNode: PropTypes.oneOfType([() => null, PropTypes.node]),

    onDeleteGroup: PropTypes.func,
  };

  static defaultProps = {
    index: 0,
    withHeader: false,
    groupTitle: l10n('room'),
    childrenNode: null,
  };

  handleRemove = () => {
    const { index, onDeleteGroup } = this.props;
    onDeleteGroup(index);
  };

  render() {
    const { index, withHeader, groupTitle, dataLocator, adultsNode, childrenNode } = this.props;

    return (
      <div className={styles.TravellersItem}>
        {withHeader && (
          <div className={styles.header}>
            <div className={styles.title}>
              {index + 1} {groupTitle}
            </div>
            <ActionButton
              className={styles.remover}
              dataLocator={dataLocator}
              onClick={this.handleRemove}
            >
              {l10n('deleteGroup')}
            </ActionButton>
          </div>
        )}

        {adultsNode}
        {childrenNode}
      </div>
    );
  }
}

export default TravellersItem;
